import React, { useState, useEffect } from "react";
import SignInForm from "./SignInForm";
import SignUpForm from "./SignUpForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import ResetPasswordForm from "./ResetPasswordForm";

export default function AuthContainer() {
    const [type, setType] = useState("signIn");
    const [resetToken, setResetToken] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("reset_password_token");
        if (token) {
            setResetToken(token);
            setType("resetPassword");
        }
    }, []);

    const handleOnClick = text => {
        if (text !== type) {
            setType(text);
            return;
        }
    };
    const rootElement = document.getElementById('root');
    const logoUrl = rootElement.getAttribute('data-logo-url');

    if (type === "forgotPassword") {
        return (
            <div className="auth-container">
                <img src={logoUrl} alt="Logo HEX-Agency" className="auth-image"/>
                <div className="auth-box" id="auth-box">
                    <ForgotPasswordForm onSwitchToSignIn={() => setType("signIn")} />
                </div>
            </div>
        );
    }

    if (type === "resetPassword") {
        return (
            <div className="auth-container">
                <img src={logoUrl} alt="Logo HEX-Agency" className="auth-image"/>
                <div className="auth-box" id="auth-box">
                    <ResetPasswordForm
                        token={resetToken}
                        onSwitchToSignIn={() => {
                            setType("signIn");
                            window.history.replaceState({}, document.title, window.location.pathname);
                        }}
                    />
                </div>
            </div>
        );
    }

    const containerClass =
        "auth-box " + (type === "signUp" ? "right-panel-active" : "");
    return (

        <div className="auth-container">
            <img src={logoUrl} alt="Logo HEX-Agency" className="auth-image"/>
            <div className={containerClass} id="auth-box">
                <SignUpForm/>
                <SignInForm onSwitchToForgotPassword={() => setType("forgotPassword")}/>
                <div className="auth-overlay-container">
                    <div className="auth-overlay">
                        <div className="auth-overlay-panel auth-overlay-left">
                            <h1 className="auth-title">Tu es de retour !</h1>
                            <p className="auth-paragraph">
                                Pour te connecter, merci de rentrer tes informations personnelles
                            </p>
                            <button
                                className="auth-button panel"
                                id="signIn"
                                onClick={() => handleOnClick("signIn")}
                            >
                                Se connecter
                            </button>
                        </div>
                        <div className="auth-overlay-panel auth-overlay-right">
                            <h1 className="auth-title">Bienvenue !</h1>
                            <p className="auth-paragraph">Entre tes informations personnelles pour commencer à utiliser
                                la plateforme</p>
                            <button
                                className="auth-button panel"
                                id="signUp"
                                onClick={() => handleOnClick("signUp")}
                            >
                                Créer mon compte
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
